<template>
  <div class="animated fadeIn inventory--inventory-list">
    <b-row id="inventory-header-nav">
      <b-col md="6">
        <h1 id="inventory-header-nav-txt">
          Inventory List
          <records-count :total="pageInfo.totalItems" />
        </h1>
      </b-col>
      <b-col md="6">
        <div class="buttons-panel">
          <b-button @click="getInventoryExcel()" title="Download" size="sm" style="margin-right: 30px;margin-top: 5px">
            <i class="fa fa-download" aria-hidden="true"></i>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div style="margin-top: 41px;" class="card">
          <div class="card-body">
            <b-row class="search">
              <b-col cols="4">
                <b-form-input
                  size="sm"
                  class="mr-sm-2"
                  placeholder="Search"
                  left
                  @input="onSearch"
                  v-bind:value="searchQuery"
                ></b-form-input>
              </b-col>
            </b-row>
            <grid-component
              isResizable
              isReorderable
              isSortable
              :canEdit="checkClaim(CAN_EDIT_INVENTORY)"
              :canDelete="checkClaim(CAN_DELETE_INVENTORY)"
              :gridId="gridId"
              :pageable="pageable"
              :skip="pageInfo.pageSize * (pageInfo.pageNumber - 1)"
              :take="pageInfo.pageSize"
              :itemData="itemData"
              :navigationField="'partNumber'"
              :dynamicValToLink="'-split-'"
              :onDynamicNav="showDetail"
              :pageSizes="pageInfo.pageSize"
              :totalItems="pageInfo.totalItems"
              :fields="fields"
              :sortBy="pageInfo.sortBy"
              :sortOrder="pageInfo.sortOrder"
              :sortMethod="sortInventory"
              :onEdit="openEdit"
              :onDelete="onDelete"
              :styleCustom="'height: 700px'"
              @getData="onGetData"
              :isTblLoader="tblLoader"
            />
          </div>
        </div>
      </b-col>
    </b-row>
    <b-modal id="split-details-modal" ref="split-details-modal" hide-footer>
      <template slot="modal-header">
        <h5 class="modal-title">
          {{ 'Inventory Split Details for Part ' + inventoryOnSplit.partNumber }}
          <i v-show="isLoadingSplit" class="fa fa-spinner fa-pulse fa-fw"></i>
        </h5>
      </template>
      <inventory-split-component />
    </b-modal>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
  import { debounce } from 'lodash';

  import ProductAlert from '@/shared/components/ProductAlert';
  import { ALERT_LOCATION, SORT_ORDER, GRID_ID, GRID_PAGE_SIZES } from '@/shared/constants';
  import { date } from '@/shared/filters';
  import { sortChange, prepareColumnsData } from '@/shared/helpers';
  import GridSettings from '@/shared/components/GridSettings';

  import { DEFAULT_SORT_BY } from './constants';
  import AddInventory from './components/AddInventory';
  import GridComponent from '@/shared/components/GridComponent';
  import InventorySplitComponent from '@/shared/components/InventorySplits';
  import inventoryFields from './fields';

  const SEARCH_DEBOUNCE_TIME = 750;

  export default {
    data() {
      return {
        date,
        prepareColumnsData,
        pageNumber: 1,
        skip: 0,
        take: 50,
        fields: inventoryFields,
        selectAll: false,
        location: ALERT_LOCATION.INVENTORY_GRID,
        pageable: {
          pageSizes: GRID_PAGE_SIZES,
        },
        inventoryOnSplit: {},
        isLoadingSplit: false,
      };
    },
    metaInfo: () => ({
      title: 'Inventory',
    }),
    filters: {
      date
    },
    components: {
      AddInventory,
      ProductAlert,
      GridSettings,
      GridComponent,
      InventorySplitComponent
    },
    computed: {
      ...mapState('inventory', [
        'gridList',
        'pageInfo',
        'searchQuery',
        'tblLoader'
      ]),

      ...mapGetters('account', ['gridSettingsById']),

      itemData() {
        if (this.gridList == undefined || !this.gridList.length) return [];
        return this.gridList.map((inventory) => ({ ...inventory}));
      },

      gridId() {
        return GRID_ID.INVENTORY;
      },
      gridSettings() {
        return this.gridSettingsById(this.gridId);
      },
      // isSortDesc: function() {
      //   return this.pageInfo.sortOrder == SORT_ORDER.DESC;
      // },
      selectedIds() {
        return this.gridList
          .filter(inventory => inventory.selected)
          .map(inventory => inventory.id);
      },
      // sortDetails: function() {
      //   if (this.pageInfo.sortBy) {
      //     return [{ field: this.pageInfo.sortBy, dir: this.pageInfo.sortOrder.toLowerCase() }];
      //   }
      //
      //   if (this.gridSettings.sort) {
      //     return [{ field: this.gridSettings.sort.sortBy, dir: this.gridSettings.sort.sortOrder.toLowerCase() }];
      //   }
      //
      //   return [];
      // },
    },
    methods: {
      // ...mapMutations('inventory',['setSearchQuery', 'setInventorySplitList', 'setItem']),
      ...mapMutations('inventory',['setItem']),
      ...mapActions('inventory', [
        'getInventory',
        'sortInventory',
        // 'getPage',
        'searchInventory',
        'getInventoryExcel',
        'deleteInventory',
        'getInventorySplits'
      ]),
      ...mapActions('account', ['saveGridSettings']),
      async onGetData(params) {
        await this.getInventory(params);
      },
      onSearch: debounce(function(e) {
        this.searchInventory(e);
      }, SEARCH_DEBOUNCE_TIME),
      openEdit(row){
        this.$router.push({
          name: 'inventory.partDetails',
          params: { id: row.id },
        });
      },
      pushToDetails(row) {
        this.$router.push({
          name: 'inventory.partDetails',
          params: { partId: row.dataItem.partId },
        });
      },
      async onDelete(inventory) {
        const deleteConfirmed = await this.openConfirmBox({message: `Are you sure you want to delete Inventory (${inventory.id}) ${inventory.partNumber}?`});
        if (deleteConfirmed) {
          await this.deleteInventory(inventory.id)
          this.getInventory({});
        }
      },
      async showDetail(row) {
        try {
          this.isLoadingSplit = true;
          // this.setInventorySplitList([]);
          this.setItem({ resource: 'inventorySplitList', payload: [] });
          this.inventoryOnSplit = row;
          this.$bvModal.show('split-details-modal');
          await this.getInventorySplits(row.id);
          this.isLoadingSplit = false;
        }catch (e) {
          this.isLoadingSplit = false;
        }
      }
    },
    watch: {
      selectAll: function(isSelected) {
        this.gridList.forEach((inventory, index) => {
          this.gridList[index].selected = isSelected;
        });
      },
      pageInfo(newPageInfo) {
        this.pageNumber = newPageInfo.pageNumber;
        this.take = newPageInfo.pageSize;
      },
      take(pageSize) {
        this.saveGridSettings({
          id: GRID_ID.INVENTORY,
          settings: {
            ...this.gridSettings,
            pageSize,
          },
        });
      },
    },
    async mounted() {
      if('clear' in this.$route.query) {
        this.pageInfo.pageNumber = 1;
        // this.setSearchQuery();
        this.setItem({ resource: 'searchQuery', payload: null });
        this.clearRoute();
      }else{
        this.skip = this.pageInfo.pageSize * (this.pageInfo.pageNumber - 1);
        this.take = this.pageInfo.pageSize;
        this.setItem({ resource: 'pageInfo', payload: {...this.pageInfo, ...this.gridSettings.sort, ...this.gridSettings.pageSize} });
        await this.getInventory({});
      }
    },
  };
</script>

<style lang="scss">

  #inventory-header-nav {
    width: 100%;
    z-index: 1000;
    position: fixed;
    border-bottom: 1px solid rgb(200, 206, 211);
    background: #fff;
  }

  #inventory-header-nav-txt {
    background-color: #fff;
    padding: 8px;
    font-size: 20px;
    margin: 0px;
  }

  .inventory {
    &--inventory-list {
      .tools > * {
        margin: 0 0 0 3px;
      }
      .search {
        margin-bottom: 1.25rem;
      }
      .b-pagination {
        justify-content: center;
      }
      table td {
        cursor: pointer;
      }
      .buttons-panel {
        text-align: right;
      }
    }
  }
</style>
